import axios from 'axios'
import session from 'vue-cookies'
var url = "https://api.bertiebets.com/reports"
var key = session.get('bertiebets.admin.key')
var headers = { headers: { 'x-api-key': key } }
var cache = {}
var mock = false
export function getEvaluationReport(configName, datasetNumber, burstCache) {
  return new Promise((resolve, reject) => {
    if (cache[configName] && cache[configName][datasetNumber] && !burstCache) {
      console.log("Got from cache")
      console.log(cache[configName][datasetNumber].races[0])
      resolve(cache[configName][datasetNumber])
    } else {
      if (mock) {
        var reportFile = require('../assets/report')
        if (!cache[configName]) cache[configName] = {}
        cache[configName][datasetNumber] = reportFile
        resolve(reportFile)
      } else {
        axios
          .get(url + "/evaluation-reports/" + configName + "/main/" + datasetNumber, headers)
          .then(response => {
            if (response.status === 200) {
              if (!cache[configName]) cache[configName] = {}
              cache[configName][datasetNumber] = response.data
              console.log(cache[configName][datasetNumber].races[0])
              resolve(response.data)
            } else {
              reject(response.status)
            }
          })
          .catch(err => {
            reject(err)
          })
      }
    }
  })
}

export function getEvaluationReports() {
  return new Promise((resolve, reject) => {
    axios
      .get(url + "/evaluation-reports", headers)
      .then(response => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          reject(response.status)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}
